import React from "react";
import type { ReactNode } from "react";
import cx from "classnames";

type Level = 1 | 2 | 3 | 4 | 5 | 6;
type Props = {
  "data-cy"?: string;
  as: `h${Level}`;
  className?: string;
  fontFamily?: string;
  fontWeight?: string;
  textAlign?: string;
  textColour?: string;
  textColourHover?: string;
  textTransform?: string;
  children: ReactNode;
};

const Heading: React.FC<Props> = ({
  "data-cy": dataCy,
  as: Component,
  children,
  className,
  fontWeight,
  fontFamily,
  textAlign,
  textColour,
  textColourHover,
  textTransform,
}) => {
  const fontWeightStyle = fontWeight
    ? `font-${fontWeight}`
    : "[font-weight:var(--heading-font-weight)]";
  const fontFamilyStyle = fontFamily
    ? fontFamily
    : "[font-family:var(--heading-font)]"; //--heading-font
  const alignStyle = `text-${textAlign ? textAlign : "center"}`;
  const textColourStyle = `text-${
    textColour ? textColour : "[color:var(--heading-color)]"
  }`;
  const textColourHoverStyle = `hover:text-${
    textColourHover ? textColourHover : "[color:var(--heading-color)]"
  }`;
  const textTransformStyle = textTransform
    ? textTransform
    : "[text-transform:var(--heading-case)]";

  const styles = cx(
    "leading-tight",
    alignStyle,
    className,
    fontFamilyStyle,
    fontWeightStyle,
    textColourStyle,
    textColourHoverStyle,
    textTransformStyle
  );

  return (
    <Component data-cy={dataCy} className={styles}>
      {children}
    </Component>
  );
};

export default Heading;
